import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/katex/dist/katex.min.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/github.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/gmail.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/info/page.module.css");
